import { GetVerificationCodeBatchesParams } from "@bvhi/backend-api/apis/model/getVerificationCodeBatchesParams";
import { VerificationCodeBatchSortByParam } from "@bvhi/backend-api/apis/model/verificationCodeBatchSortByParam";
import { createFileRoute } from "@tanstack/react-router";
import { WithErrorBoundary } from "../../../hoc/with-error-boundary";
import { withPermissionCheck } from "../../../hoc/with-permission-check";
import { VerificationCodesListView } from "../../../views/app/verification-code/list/verification-codes-list-view";

export const Route = createFileRoute("/_main/app/verification-codes/")({
  validateSearch: (search: Record<string, unknown>): GetVerificationCodeBatchesParams => {
    return {
      page: Number(search?.page ?? 0),
      size: Number(search?.size ?? 25),
      sort: (search?.sort as VerificationCodeBatchSortByParam[]) || [VerificationCodeBatchSortByParam.CREATED_AT_ASC],
    };
  },
  component: () =>
    WithErrorBoundary({
      Component: withPermissionCheck({ Component: VerificationCodesListView }),
    }),
});
